// A signature (drawn or photo) is synced to the other teleconsent participant
// through the realtime channel as part of the collaborative document data
// diff. Ably rejects any single published message larger than 64KiB, so an
// oversized signature image silently fails to sync and is never committed
// for the other side (see PROD-9867).
//
// Keep both signature paths' image budgets here so a future change to the
// transport limit (or to the ~360px signature-block display width) touches
// one place instead of drifting between the draw and photo paths.
//
// NOTE: these budgets only cover the image payload(s) themselves. The
// published diff also carries a handful of small fields alongside the
// picture (date, ip, pictureName, ...) which are negligible in size (well
// under 1KB combined) relative to the budgets below and the 64KiB transport
// limit - they are intentionally not accounted for here.
export const ABLY_MESSAGE_LIMIT_KB = 64;
// Drawn signature: a single flattened image, capped comfortably under the
// transport limit.
export const MAX_DRAWN_SIGNATURE_SIZE_KB = 30;
// The signature is only ever displayed at ~361px wide, so there is nothing to
// gain from storing a higher-resolution (e.g. retina) backing store.
export const MAX_DRAWN_SIGNATURE_WIDTH = 361;
// Photo signature: sent as two images (captured person photo + rendered
// signature-name text), so each is capped at half the drawn-signature budget
// to keep the combined payload comfortably under the transport limit too.
export const MAX_PHOTO_SIGNATURE_IMAGE_SIZE_KB = 15;
// The captured person photo is cropped to a square, so this is both its
// width and height (not just a width).
export const MAX_PHOTO_SIGNATURE_SIZE_PX = 370;
